import { EventTracking } from './event-tracking';
import { ViewTracking } from './view-tracking';
import { ActionTracking } from './action-tracking';
import { BaseComponent2 } from '../../_common/client/base-component2';
import { FeatureTrackingHelper } from './feature-tracking-helper';

export const ROOT_SELECTOR = '.js_of_offers-tracking__data';

export class OffersTrackingComponent extends BaseComponent2 {
    public rootSelector = ROOT_SELECTOR;

    public async onReloadComponentEvent(): Promise<void> {
        const featureTrackingHelper = new FeatureTrackingHelper(this.getRootElement());
        const actionTracking = new ActionTracking(featureTrackingHelper);
        const viewTracking = new ViewTracking(featureTrackingHelper);
        const eventTracking = new EventTracking();

        actionTracking.registerTracking();
        viewTracking.track();
        eventTracking.registerTracking();
    }
}
